<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card mb-4">
          <div class="card-header pb-0 d-flex justify-content-between">
            <div>
              <h3 class="card-title text-primary mb-0">Nueva ruta</h3>
              <div class="sub-line"></div>
            </div>
          </div>
          <div class="card-body">
            <div class="col-sm mx-60">
              <trail-form :entity="newTrail" action="create" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import TrailForm from "./TrailForm.vue";

    const newTrail = ref({
      name: null,
      description: null,
      latitude: null,
      longitude: null,
      locality: null,
      subtitle: "",
      duration: null,
      difficulty: null,
      places: 0,
      orderNumber: 0,
      tags: null,
      images: null,
      images360: null,
      file: null,
      naturalSpace: null,
      unevenness: null,
      positive_unevenness: null,
      negative_unevenness: null,
      topics: [],
      tilesUrl: null,
      lang: 'es',
    });

</script>
